import { turboproApi } from '@/api/turbopro';
import type { GerarRelatorioPDFLotePayload, GerarRelatorioPDFLoteResponse } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function gerarRelatorioPdfLoteApi(
  payload: GerarRelatorioPDFLotePayload
): Promise<GerarRelatorioPDFLoteResponse> {
  const resposta = await turboproApi<GerarRelatorioPDFLoteResponse>(
    'Relatorios/GerarRelatorioPDFLote',
    { method: 'POST', body: payload, headers: getRelatoriosHeaders() }
  );
  return resposta.data;
}
